/** Get User Locale based on `window.navigator.language`, defaulting to English  */
export const getUserLocale = () => {
  return (
    navigator.language ||
    (navigator.languages && navigator.languages[0]) ||
    "en-US"
  );
};

/** Format date based on user locale. 
 * 
 * Example usage: 
 * 
 * ```ts
 * toLocaleDateString({
    date: new Date(transcript.updatedAt),
    options: {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
    },
  }) // "Jan 1, 2022, 12:00 AM PST"
 * ```
  */
export function toLocaleDateString({
  date,
  options,
  locale,
}: {
  date: Date;
  options?: Intl.DateTimeFormatOptions;
  /** If not provided, locale is determined based on `navigator.language` automatically */
  locale?: string;
}) {
  const userLocale = locale || getUserLocale();

  return date.toLocaleString(userLocale, options);
}
